export const levels = [
  {
    key: 'levelsix',
    value: '6단계'
  },
  {
    key: 'levelfive',
    value: '5단계'
  },
  {
    key: 'levelfour',
    value: '4단계'
  },
  {
    key: 'levelthree',
    value: '3단계'
  },
  {
    key: 'leveltwo',
    value: '2단계'
  },
  {
    key: 'levelone',
    value: '1단계'
  }
];

export const severityTP = [
  {
    key: 'frontserious',
    value: '전 > 심각'
  },
  {
    key: 'frontseverity',
    value: '전 > 중증도'
  },
  {
    key: 'frontlight',
    value: '전 > 경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'backlight',
    value: '후 > 경미'
  },
  {
    key: 'backseverity',
    value: '후 > 중증도'
  },
  {
    key: 'backserious',
    value: '후 > 심각'
  }
];

export const severityNSP = [
  {
    key: 'leftserious',
    value: '좌 > 심각'
  },
  {
    key: 'leftseverity',
    value: '좌 > 중증도'
  },
  {
    key: 'leftlight',
    value: '좌 > 경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'rightlight',
    value: '우 > 경미'
  },
  {
    key: 'rightseverity',
    value: '우 > 중증도'
  },
  {
    key: 'rightserious',
    value: '우 > 심각'
  }
];

export const severityK = [
  {
    key: 'flexionserious',
    value: '굴 > 심각'
  },
  {
    key: 'flexionseverity',
    value: '굴 > 중증도'
  },
  {
    key: 'flexionlight',
    value: '굴 > 경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'extensionlight',
    value: '신 > 경미'
  },
  {
    key: 'extensionseverity',
    value: '신 > 중증도'
  },
  {
    key: 'extensionserious',
    value: '신 > 심각'
  }
];

export const severityOX = [
  {
    key: 'varus',
    value: '내반슬'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'valgus',
    value: '외반슬'
  }
];

export const severityLR = [
  {
    key: 'pserious',
    value: '회내 > 심각'
  },
  {
    key: 'pseverity',
    value: '회내 > 중증도'
  },
  {
    key: 'plight',
    value: '회내 > 경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'slight',
    value: '회외 > 경미'
  },
  {
    key: 'sseverity',
    value: '회외 > 중증도'
  },
  {
    key: 'sserious',
    value: '회외 > 심각'
  }
];

export const severityNC = [
  {
    key: 'caution',
    value: '주의'
  },
  {
    key: 'normal',
    value: '정상'
  }
];

export const romPart = [
  {
    key: 'neckFlexion',
    value: '목 굴곡',
    indicators: severityNC
  },
  {
    key: 'neckExtension',
    value: '목 신전',
    indicators: severityNC
  },
  {
    key: 'neckLat',
    value: '목 측굴',
    indicators: [
      {
        key: 'neckLatFlexL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'neckLatFlexR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'trunkLat',
    value: '몸통 측굴',
    indicators: [
      {
        key: 'trunkLatFlexL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'trunkLatFlexR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'lumbarFlexion',
    value: '허리 굴곡',
    indicators: severityNC
  },
  {
    key: 'lumbarExtension',
    value: '허리 신전',
    indicators: severityNC
  },
  {
    key: 'shoulderAbduction',
    value: '어깨 외전',
    indicators: [
      {
        key: 'shoulderAbductionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'shoulderAbductionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'shoulderFlexion',
    value: '어깨 굴곡',
    indicators: [
      {
        key: 'shoulderFlexionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'shoulderFlexionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'shoulderExtension',
    value: '어깨 신전',
    indicators: [
      {
        key: 'shoulderExtensionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'shoulderExtensionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'shoulderIntRotation',
    value: '어깨내회전',
    indicators: [
      {
        key: 'shoulderIntRotationL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'shoulderIntRotationR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'shoulderExtRotation',
    value: '어깨외회전',
    indicators: [
      {
        key: 'shoulderExtRotationL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'shoulderExtRotationR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'elbowFlexion',
    value: '팔꿈치굴곡',
    indicators: [
      {
        key: 'elbowFlexionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'elbowFlexionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'elbowExtension',
    value: '팔꿈치신전',
    indicators: [
      {
        key: 'elbowExtensionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'elbowExtensionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'kneeFlexion',
    value: '무릎굴곡OKC',
    indicators: [
      {
        key: 'kneeFlexionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'kneeFlexionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'kneeExtension',
    value: '무릎신전OKC',
    indicators: [
      {
        key: 'kneeExtensionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'kneeExtensionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'hipAbduction',
    value: '고관절외전',
    indicators: [
      {
        key: 'hipAbductionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'hipAbductionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'hipFlexion',
    value: '고관절굴곡',
    indicators: [
      {
        key: 'hipFlexionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'hipFlexionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'hipExtension',
    value: '고관절신전',
    indicators: [
      {
        key: 'hipExtensionL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'hipExtensionR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'hipIntRotation',
    value: '고관절내회전',
    indicators: [
      {
        key: 'hipIntRotationL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'hipIntRotationR',
        value: '우',
        severity: severityNC
      }
    ]
  },
  {
    key: 'hipExtRotation',
    value: '고관절외회전',
    indicators: [
      {
        key: 'hipExtRotationL',
        value: '좌',
        severity: severityNC
      },
      {
        key: 'hipExtRotationR',
        value: '우',
        severity: severityNC
      }
    ]
  }
];

export const posturePart = [
  {
    key: 'neck',
    value: '목',
    indicators: [
      {
        key: 'turtleneck',
        value: '거북목',
        severity: severityTP
      },
      {
        key: 'neckside',
        value: '목측굴',
        severity: severityNSP
      }
    ]
  },
  {
    key: 'shoulder',
    value: '어깨',
    indicators: [
      {
        key: 'shoulderbalance',
        value: '어깨균형',
        severity: severityNSP
      }
    ]
  },
  {
    key: 'pelvis',
    value: '골반',
    indicators: [
      {
        key: 'pelvisbalance',
        value: '골반균형',
        severity: severityNSP
      },
      {
        key: 'pelvictilt',
        value: '골반경사',
        severity: severityTP
      }
    ]
  },
  {
    key: 'knee',
    value: '무릎',
    indicators: [
      {
        key: 'kneeflexion',
        value: '무릎굴곡',
        severity: severityK
      }
    ]
  },
  {
    key: 'legs',
    value: 'OX다리',
    indicators: [
      {
        key: 'oxleftleg',
        value: '좌',
        severity: severityOX
      },
      {
        key: 'oxrightleg',
        value: '우',
        severity: severityOX
      }
    ]
  },
  {
    key: 'foot',
    value: '발과회내외',
    indicators: [
      {
        key: 'leftfoot',
        value: '좌',
        severity: severityLR
      },
      {
        key: 'rightfoot',
        value: '우',
        severity: severityLR
      }
    ]
  },
  {
    key: 'musculoskeletalLevel',
    value: '근골격지수',
    indicators: levels
  }
];
